module.exports = __webpack_public_path__ + "img/ic_market.767538bb.svg";